module.exports = __webpack_public_path__ + "static/media/59784d72-a9b7-4308-b868-cfe862ca76da.1acd0e37.png";